import { Button, Typography } from "@mui/material";
import { Dialog } from "components/Dialog";

import type { UnsavedChangesDialogProps } from "./useUnsavedChangesPrompt";

/**
 * Asks before throwing away unsaved text. In-app rather than `window.confirm`,
 * which blocks browser automation.
 */
export function UnsavedChangesDialog({ request, onChoose }: UnsavedChangesDialogProps) {
  return (
    <Dialog
      open={Boolean(request)}
      onClose={() => onChoose("cancel")}
      title="Unsaved changes"
      maxWidth="xs"
      fullWidth
      noPrimaryAction
      additionalPrimaryActionElements={[
        <Button key="cancel" onClick={() => onChoose("cancel")}>
          Keep editing
        </Button>,
        <Button key="discard" color="error" onClick={() => onChoose("discard")}>
          Discard
        </Button>,
        ...(request?.canSave
          ? [
              <Button key="save" variant="contained" onClick={() => onChoose("save")}>
                Save
              </Button>,
            ]
          : []),
      ]}
    >
      <Typography variant="body2">{request?.message}</Typography>
    </Dialog>
  );
}
